import { render, staticRenderFns } from "./EvaluationCrud.vue?vue&type=template&id=8ec783ae&"
import script from "./EvaluationCrud.vue?vue&type=script&lang=js&"
export * from "./EvaluationCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports